import React from "react";
import ProjectsLineChart from "./ProjectsLineChart";
import PieChartWithPaddingAngle from "../SalesDirectory/PieChart";
import ArcDesign from "../SalesDirectory/ArcDesign";

const ProjectsDashboard = () => {
  const dummyProjects = [
    { id: 1, name: "ERP System", manager: "Faizan", status: "Completed", budget: 25000 },
    { id: 2, name: "CRM Development", manager: "Ahmed", status: "In Progress", budget: 18000 },
    { id: 3, name: "Mobile App", manager: "Ali", status: "Pending", budget: 12000 },
    { id: 4, name: "Website Revamp", manager: "Usman", status: "Completed", budget: 15000 },
    { id: 5, name: "Inventory Module", manager: "Zaid", status: "In Progress", budget: 20000 },
  ];

  return (
    <div className="p-6 space-y-6">

      {/* Top Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

        {/* LEFT SIDE - TABLE */}
        <div className="lg:col-span-2 bg-white shadow-lg rounded-xl p-4">
          <h2 className="text-xl font-semibold mb-4">Project Summary</h2>

          <div className="overflow-x-auto">
            <table className="min-w-full text-sm text-left border">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-3 border">Project</th>
                  <th className="p-3 border">Manager</th>
                  <th className="p-3 border">Status</th>
                  <th className="p-3 border">Budget ($)</th>
                </tr>
              </thead>
              <tbody>
                {dummyProjects.map((project) => (
                  <tr key={project.id} className="hover:bg-gray-50">
                    <td className="p-3 border">{project.name}</td>
                    <td className="p-3 border">{project.manager}</td>
                    <td
                      className={`p-3 border font-medium ${
                        project.status === "Completed"
                          ? "text-green-600"
                          : project.status === "In Progress"
                          ? "text-yellow-600"
                          : "text-red-600"
                      }`}
                    >
                      {project.status}
                    </td>
                    <td className="p-3 border">{project.budget}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* RIGHT SIDE - ARC + PIE */}
        <div className="flex flex-col gap-6">

          {/* Arc Charts */}
          <div className="bg-white shadow-lg rounded-xl p-4 flex justify-around">
            <ArcDesign valueFromParent={29} colorFromParent={"#ebd729"} />
            <ArcDesign valueFromParent={79} colorFromParent={"#35d419"} />
          </div>

          {/* Pie Chart */}
          <div className="bg-white shadow-lg rounded-xl p-4">
            <PieChartWithPaddingAngle />
          </div>

        </div>
      </div>

      {/* Bottom Section - Line Chart */}
      <div className="bg-white shadow-lg rounded-xl p-4">
        <ProjectsLineChart />
      </div>

    </div>
  );
};

export default ProjectsDashboard;
